import React, { useState } from 'react';
import { CreateTrialAccountFormValues } from './CreateTrialAccountTypes';
import { HEARD_FROM_OPTIONS, TrialStepsEnum, VOLABY_REGION, VOLS_NO_OPTION } from './CreateTrialAccountConsts';
import { YourDetailStep } from './create-trial-account-steps/YourDetailStep';
import { OrgDetailStep } from './create-trial-account-steps/OrgDetailStep';
import { TermsOfUseStep } from './create-trial-account-steps/TermsOfUseStep';
import { useTrialAccountActions } from './CreateTrialAccountActions';
import { CreatingAccountPrompt } from './CreatingAccountPrompt';
import { ErrorPrompt } from './ErrorPrompt';
import { VerifyEmailPrompt } from './VerifyEmailPrompt';

export const CreateTrialAccountForm = () => {
  const [currentTrialStep, setCurrentTrialStep] = useState<string>(TrialStepsEnum.YOUR_DETAIL);
  const [trialData, setTrialData] = useState<CreateTrialAccountFormValues>({
    firstName: '',
    lastName: '',
    email: '',
    contactNumber: '',
    tenantName: '',
    region: VOLABY_REGION[0].value,
    vols: VOLS_NO_OPTION[0],
    hearAt: HEARD_FROM_OPTIONS[0],
    agreedTerms: false,
  });

  const {
    runCreateTrialAccount,
    runCreateTrialAccountLoading,
    runCreateTrialAccountSuccess,
    runCreateTrialAccountError,
  } = useTrialAccountActions();

  const handleNextStep = (newData: any, step: string) => {
    setTrialData((prev) => ({ ...prev, ...newData }));

    if (step === TrialStepsEnum.SUBMIT) {
      runCreateTrialAccount(newData);
      return;
    }

    setCurrentTrialStep(step);
  };

  const handlePrevStep = (newData: any, step: string) => {
    setTrialData((prev) => ({ ...prev, ...newData }));
    setCurrentTrialStep(step);
  };

  return runCreateTrialAccountLoading ? (
    <CreatingAccountPrompt />
  ) : runCreateTrialAccountError ? (
    <ErrorPrompt />
  ) : runCreateTrialAccountSuccess ? (
    <VerifyEmailPrompt firstName={trialData.firstName} email={trialData.email} />
  ) : currentTrialStep === TrialStepsEnum.YOUR_DETAIL ? (
    <YourDetailStep trialData={trialData} next={handleNextStep} />
  ) : currentTrialStep === TrialStepsEnum.ORG_DETAIL ? (
    <OrgDetailStep trialData={trialData} next={handleNextStep} prev={handlePrevStep} />
  ) : currentTrialStep === TrialStepsEnum.TERMS_OF_USE ? (
    <TermsOfUseStep trialData={trialData} next={handleNextStep} prev={handlePrevStep} />
  ) : null;
};
